import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.css']
})
export class PageTitleComponent implements OnInit {

  @Input() pageTitleA: string;
  @Input() pageTitleB: string;
  @Input() pageSubtitle: string;
  @Input() pageLink: string;
  @Input() secondColor: string;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  goToPage() {
    if (this.pageLink !== undefined){
      this.router.navigateByUrl(this.pageLink);
    }
  }

  getCssColor(){
    if(this.secondColor){
      return 'color:' + this.secondColor;
    }else{
      return 'color: var(--voyjaleas-medium-blue)'; 
    }
  }

}

